import React from "react";
import { Circle, MainContainer, Square, Triangle } from "./styles";
import usePost from "../../hooks/usePost";
import { SmartGoalGroup } from "../../hooks/usePost/types";

const Guide: React.FC = (): JSX.Element => {
  const { postState, updateState } = usePost();

  const switchCaption = (item: SmartGoalGroup) => {
    switch (item.view) {
      case "triangle":
        return (
          <Triangle
            isSelected={postState.selectedSmartGoal === item.smartGoalId}
            onClick={() => updateState({ selectedSmartGoal: item.smartGoalId })}
          />
        );
      case "circle":
        return (
          <Circle
            isSelected={postState.selectedSmartGoal === item.smartGoalId}
            onClick={() => updateState({ selectedSmartGoal: item.smartGoalId })}
          />
        );
      case "square":
        return (
          <Square
            isSelected={postState.selectedSmartGoal === item.smartGoalId}
            onClick={() => updateState({ selectedSmartGoal: item.smartGoalId })}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <MainContainer>
      {postState.groups.map((item) => switchCaption(item))}
    </MainContainer>
  );
};

export default Guide;
